export function findCity(googleObj, country) {
  function removeAccents(inputString) {
    const accentMap = {
      а́: 'а',
      е́: 'е',
      ё́: 'ё',
      и́: 'и',
      о́: 'о',
      у́: 'у',
      ы́: 'ы',
      э́: 'э',
      ю́: 'ю',
      я́: 'я',
      А́: 'А',
      Е́: 'Е',
      Ё́: 'Ё',
      И́: 'И',
      О́: 'О',
      У́: 'У',
      Ы́: 'Ы',
      Э́: 'Э',
      Ю́: 'Ю',
      Я́: 'Я',
    }

    const accents = Object.keys(accentMap).join('|')
    const accentRegex = new RegExp(accents, 'g')

    return inputString.replace(accentRegex, (match) => accentMap[match])
  }
  let city = false
  city = googleObj.address_components.find(
    (field) =>
      field.types.includes('locality') && field.types.includes('political')
  )

  if (city?.long_name === 'Москва') {
    // проверка кейсов "Щербинка, Москва", "Троицк, Москва" на наличие альтернативного значения в administrative_area_level_3
    const rayonMsk = googleObj.address_components.find(
      (field) =>
        field.types.includes('administrative_area_level_3') &&
        field.types.includes('political')
    )
    const isTroitsk = ['Щербинка', 'Троицк', 'Ново-Переделкино'].includes(
      rayonMsk?.long_name
    )

    // если это указанные города, то подставляем МО
    if (rayonMsk?.long_name !== 'Москва' && isTroitsk) {
      city = rayonMsk
    }
  }

  if (country === 'SE') {
    if (!city) {
      city = googleObj.address_components.find((field) =>
        field.types.includes('postal_town')
      )
    }
    if (!city) {
      city = googleObj.address_components.find((field) =>
        field.types.includes('sublocality')
      )
    }
  } else {
    if (!city) {
      city = googleObj.address_components.find((field) =>
        field.types.includes('sublocality')
      )
    }

    if (!city) {
      city = googleObj.address_components.find((field) =>
        field.types.includes('postal_town')
      )
    }
  }

  if (!city) {
    city = googleObj.address_components.find(
      (field) =>
        field.types.includes('administrative_area_level_3') &&
        field.types.includes('political')
    )
  }

  if (!city) {
    city = googleObj.address_components.find(
      (field) =>
        field.types.includes('administrative_area_level_2') &&
        field.types.includes('political')
    )
  }

  // в Южной Корее присваивать городу значение региона: Сеулу даем не 'регион' (administrative_area_level_1), а 'город' (sublocality_level_1)
  if (country === 'KR') {
    city = googleObj.address_components.find(
      (field) =>
        field.types.includes('administrative_area_level_1') &&
        field.types.includes('political')
    )
  }

  if (country === 'RU' && city) {
    city.long_name = removeAccents(city.long_name)
    city.short_name = removeAccents(city.short_name)
  }

  if (country === 'UZ' && city.long_name === 'Tashkent') {
    city.long_name = 'Тоshkent'
    city.short_name = 'Тоshkent'
  }

  if (country === 'AT' && city.long_name === 'Wien') {
    city.long_name = 'Vienna'
    city.short_name = 'Vienna'
  }

  if (country === 'GE' && city.long_name === "T'bilisi") {
    city.long_name = 'Tbilisi'
    city.short_name = 'Tbilisi'
  }

  if (country === 'CZ' && city.long_name) {
    const pragueNames = ['Hlavní město Praha', 'Prague', 'Praha']
    if (
      pragueNames.includes(city.long_name) ||
      city.long_name.startsWith('Praha ')
    ) {
      city.long_name = 'Praha'
      city.short_name = 'Praha'
    }
  }

  if (city) {
    city.long_name = city.long_name
      .replace(/^городской округ\s+/i, '')
      .replace('город ', '')
      .trim()
    city.short_name = city.short_name
      .replace(/^городской округ\s+/i, '')
      .replace('город ', '')
      .trim()
  }

  return city
}
